import { useContext, useMemo } from 'react';
import { FileContext } from '../../../context/FileContext';
import Dropdown from 'monday-ui-react-core/dist/Dropdown';
import styled from 'styled-components';

const ZoomDropdown = styled(Dropdown)`
  width: 102px;
  z-index: 1;
  margin-right: 1rem;
`;

const PageScaleControllers = () => {
  const { pageScale, setPageScale } = useContext(FileContext);
  const zoomOptions = useMemo(
    () => [
      { value: '0.5', label: '50%' },
      { value: '0.6', label: '60%' },
      { value: '0.7', label: '70%' },
      { value: '0.8', label: '80%' },
      { value: '0.9', label: '90%' },
      { value: '1', label: '100%' },
      { value: '1.1', label: '110%' },
      { value: '1.2', label: '120%' },
      { value: '1.3', label: '130%' },
      { value: '1.4', label: '140%' },
      { value: '1.5', label: '150%' },
    ],
    [],
  );

  function handleZoomChange(value) {
    setPageScale(value);
  }

  return (
    <ZoomDropdown
      clearable={false}
      searchable={false}
      value={pageScale}
      options={zoomOptions}
      size={Dropdown.size.SMALL}
      className="dropdown-stories-styles_with-chips z-index-max"
      onChange={handleZoomChange}
    />
  );
};

export default PageScaleControllers;
